import React from 'react'
import MasterPage from './masterpage';

const Privacy = () => {
    return (
        <MasterPage id={3} heading="Privacy Policy" />
    )
}

export const FaqPage = () => (<MasterPage id={8} heading="FAQ'S" />);

export const Terms = () => (<MasterPage id={4} heading="Terms & Conditions" />); 

export default Privacy
